import api from "@/lib/api";
import { toast } from "sonner";

async function fetchInvoiceBlob(id, path = "pdf") {
  const { data } = await api.get(`/invoices/${id}/${path}`, { responseType: "blob" });
  return URL.createObjectURL(data);
}

export async function openInvoicePdf(id) {
  try {
    const url = await fetchInvoiceBlob(id);
    const w = window.open(url, "_blank");
    if (!w) { const a = document.createElement("a"); a.href = url; a.download = "invoice.pdf"; a.click(); }
  } catch (e) { toast.error("Could not open invoice PDF. Please try again."); }
}

export async function printInvoicePdf(id) {
  try {
    const url = await fetchInvoiceBlob(id);
    // Print via a hidden iframe so the browser print dialog opens WITHOUT downloading a file.
    const existing = document.getElementById("shoply-print-frame");
    if (existing) existing.remove();
    const iframe = document.createElement("iframe");
    iframe.id = "shoply-print-frame";
    iframe.style.position = "fixed"; iframe.style.right = "0"; iframe.style.bottom = "0";
    iframe.style.width = "0"; iframe.style.height = "0"; iframe.style.border = "0";
    iframe.style.visibility = "hidden";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      setTimeout(() => {
        try { iframe.contentWindow.focus(); iframe.contentWindow.print(); }
        catch (e) {
          const w = window.open(url, "_blank");
          if (w) { w.addEventListener("load", () => { try { w.focus(); w.print(); } catch (er) { /* noop */ } }); }
        }
      }, 350);
    };
    setTimeout(() => { try { URL.revokeObjectURL(url); } catch (e) { /* noop */ } }, 120000);
  } catch (e) { toast.error("Could not open the print view. Please try again."); }
}

export async function downloadInvoicePdf(id, filename = "invoice.pdf") {
  try {
    const url = await fetchInvoiceBlob(id);
    const a = document.createElement("a"); a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
  } catch (e) { toast.error("Could not download the PDF. Please try again."); }
}

export async function openPackingSlip(id) {
  try {
    const url = await fetchInvoiceBlob(id, "packing-slip");
    const w = window.open(url, "_blank");
    if (!w) { const a = document.createElement("a"); a.href = url; a.download = "packing-slip.pdf"; a.click(); }
  } catch (e) { toast.error("Could not open the packing slip. Please try again."); }
}

export async function shareInvoicePdf(id, filename = "invoice.pdf", { title, text, whatsapp, phone } = {}) {
  let blob;
  try {
    const { data } = await api.get(`/invoices/${id}/pdf`, { responseType: "blob" });
    blob = data;
  } catch (e) { toast.error("Could not generate the invoice PDF to share."); return false; }
  const file = new File([blob], filename, { type: "application/pdf" });
  // Preferred path: native file sharing (mobile shows WhatsApp, Mail, etc.)
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], title, text }); return true; }
    catch (e) { if (e && e.name === "AbortError") return true; /* else fall through to download */ }
  }
  // Fallback: download the real PDF file, then open the target app so the user attaches it
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  if (whatsapp) {
    const wa = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(text || "")}` : `https://wa.me/?text=${encodeURIComponent(text || "")}`;
    setTimeout(() => window.open(wa, "_blank"), 400);
    toast.message("Invoice PDF downloaded — attach it in WhatsApp");
  } else {
    toast.message("Invoice PDF downloaded — attach it where you want to share");
  }
  return false;
}

